export default __webpack_public_path__ + "static/media/KinesisAnalyticsV2.f2334679.svg";